import React, { useState, useEffect } from "react"
import { useQueryParamString } from "react-use-query-param-string"

import ArticleCard from "../CardTypes/ArticleCard"
import PageCard from "../CardTypes/PageCard"
import PageListingCard from "../CardTypes/PageListingCard"
import CampaignListingCard from "../CardTypes/CampaignListingCard"
import ListingPagination from "./ListingPagination"

import {
  ArticleModel,
  CampaignModel,
  PageModel,
  PageModels,
} from "../../models/pages"
import { TagModel } from "../../models/components"

interface Props {
  items: PageModels[]
  hasSidebar?: boolean
  pageListing?: boolean
  pageContext: any
}

const defaultProps = {}

export const ListingResults: React.FC<Props> = props => {
  // query params
  const [categoryParam] = useQueryParamString("category", "")
  const [pageParam, setPageParam] = useQueryParamString("p", "")

 // console.log("ListingResultsdProps: ", props.pageContext)
  // state
  const [results, setResults] = useState<PageModels[]>()
  const [pageResults, setPageResults] = useState<PageModels[]>([])

  // filter change
  useEffect(() => {
    if (props.items) {
      if (categoryParam)
        setResults(
          props.items.filter(x =>
            (x as ArticleModel).categories
              ?.map((x: TagModel) => x.display_name)
              ?.includes(categoryParam)
          )
        )
      else setResults(props.items)
    }
  }, [props.items, categoryParam])

  // pagination change
  useEffect(() => {
    if (results) {
      const end = (pageParam ? parseInt(pageParam) : 1) * hitsPerPage
      const paginated = results.slice(0, end)
      setPageResults(paginated)
    }
  }, [results, pageParam])

  // events
  const handlePageClick = (page: number) => {
    setPageParam(page.toString())
  }

  if (!results) return null
  // const hitsPerPage = results.length < 9 ? results.length : 6
  const hitsPerPage = 8

  const PageComponent = props.pageListing ? PageListingCard : PageCard

  return (
    <>
      <section>
        <div className={`grid-x flexGrid ${props.hasSidebar ? "narrow" : ""}`}>
          {pageResults.map(page => {
            const gridSize = page.listing?.listing_width || 1
            return (
              <div
                key={page.id}
                className={`cell medium-6 grid__item--${gridSize}`}
              >
                {page.internal.type === "Contentstack_article" && (
                  <ArticleCard
                    {...(page as ArticleModel)}
                    pageContext={props.pageContext}
                  />
                )}
                {page.internal.type === "Contentstack_page" && (
                  <PageComponent
                    {...(page as PageModel)}
                    pageContext={props.pageContext}
                  />
                )}
                {page.internal.type === "Contentstack_campaign" && (
                  <CampaignListingCard
                    {...(page as CampaignModel)}
                    pageContext={props.pageContext}
                  />
                )}
              </div>
            )
          })}
        </div>
      </section>

      <ListingPagination
        results={results}
        hitsPerPage={hitsPerPage}
        currentPage={parseInt(pageParam) || 1}
        handlePageClick={handlePageClick}
        pageContext={props.pageContext}
      />
    </>
  )
}

ListingResults.defaultProps = defaultProps

export default ListingResults
